import React from 'react';
import { BubbleStats } from './types';

const BubbleStatsComponent: React.FC<{ stats: BubbleStats[] }> = ({
  stats
}) => {
  const stat = stats[0];

  return (
    <div className='card'>
      <div className='card-body'>
        <h5 className='card-title'>Bubble Statistics</h5>
        <div className='card-text'>
          <table className='table table-bordered'>
            <tbody>
              <tr>
                <th scope='row'>Sessions</th>
                <td>{stat.sessions}</td>
              </tr>
              <tr>
                <th scope='row'>Average Score</th>
                <td>{(stat.averageScore || 0).toLocaleString()}</td>
              </tr>
              <tr>
                <th scope='row'>Max Score</th>
                <td>{(stat.maxScore || 0).toLocaleString()}</td>
              </tr>
              <tr>
                <th scope='row'>Bubbles Popped</th>
                <td>{stat.bubblePops.toLocaleString()}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export { BubbleStatsComponent };
